import type { LandingDesignSystem } from "@tento-ui/brand/landing/landing-section-factories";
import { css } from "@tento-ui/component-styles";
import { LANDING_ASSET_DIMENSIONS } from "./landing-asset-dimensions";

export type LonaLandingDesignSystemConfig = LandingDesignSystem & {
  pricing: {
    signupPath: string;
    contactHref: string;
  };
};

export const LonaLandingDesignSystem: LonaLandingDesignSystemConfig = {
  style: css`
    .landing-pagelet {
      background: var(--bg);
    }
  `,
  assets: {
    mainScreenshot: "/@/static/img/landing/feature-calendar.webp",
    imageDimensions: LANDING_ASSET_DIMENSIONS,
  },
  sections: {
    hero: {
      paddingY: 56,
      background: "var(--bg)",
      gap: 16,
      border: true,
      first: true,
      maxWidth: null,
    },
    features: {
      paddingY: 84,
      background: "var(--bg)",
      gap: 0,
      border: true,
      first: false,
      maxWidth: null,
    },
    socialProof: {
      paddingY: 76,
      background: "var(--bg)",
      gap: 0,
      border: true,
      first: false,
      maxWidth: null,
    },
    integrations: {
      paddingY: 76,
      background: "var(--bg)",
      gap: 0,
      border: true,
      first: false,
      maxWidth: null,
    },
    comparison: {
      paddingY: 80,
      background: "var(--bg)",
      gap: 0,
      border: true,
      first: false,
      maxWidth: null,
    },
    pricing: {
      paddingY: 80,
      background: "var(--bg)",
      gap: 0,
      border: true,
      first: false,
      maxWidth: null,
    },
    faq: {
      paddingY: 76,
      background: "var(--bg)",
      gap: 0,
      border: true,
      first: false,
      maxWidth: null,
    },
    cta: {
      paddingY: 76,
      background: "var(--bg)",
      gap: 0,
      border: false,
      first: false,
      maxWidth: null,
    },
  },
  comparison: {
    markStyle: "svg",
    fallbackDescriptions: {
      "Time as the core axis": "Every row shares the same day, week, month, or year columns.",
      "Timezone handling": "Events keep the timezone they were created in, so travel and remote work do not silently shift your plans.",
      "Timezone-stable calendar": "Events keep the timezone they were created in, so travel and remote work do not silently shift your plans.",
      "Health data": "Recovery, sleep, HRV, and workouts line up with the plans that caused them.",
      "Health rows beside events": "Recovery, sleep, HRV, and workouts line up with the plans that caused them.",
      "Formulas": "Computed rows can reference any other row by name across time ranges.",
      "Formula rows": "Computed rows can reference any other row by name across time ranges.",
      "AI-generated sheets": "Questions can turn into interactive time sheets instead of static prose.",
      "Scheduling links": "Availability can be derived from the same source of truth you use to plan.",
      "Weather and cities": "Forecasts become rows you can compare against travel days and events.",
      "Data model": "New sources fit the same row-and-time model instead of becoming one-off widgets.",
      "Extensible data model": "New sources fit the same row-and-time model instead of becoming one-off widgets.",
      "Multiple planning horizons": "Switch between day, week, month, and year views without rebuilding the data.",
      "Rows you can rearrange": "Events, metrics, formulas, and labels can be arranged into the view you need.",
      "Reference material in flow": "Formula help and command access live inside the same product surface.",
      "Team planning without health overshare": "Teams can plan around shared availability while individual health data remains private.",
    },
  },
  pricing: {
    signupPath: "/signin",
    contactHref: "mailto:james@lona.so",
  },
};
